import { render, staticRenderFns } from "./TextLabel.vue?vue&type=template&id=bad89408&"
import script from "./TextLabel.vue?vue&type=script&lang=js&"
export * from "./TextLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports